const autoNgTemplateLoaderTemplate1 = require('./resourcePool.html');

angular.module('shbdeployer.kubernetes').component('kubernetesResourcePoolView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'KubernetesResourcePoolController',
  controllerAs: 'ctrl',
  bindings: {
    endpoint: '<',
  },
});
